import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../commonFields";

export const horizontalTabBlockConfig: Omit<RegisteredComponent, "component"> =
  {
    name: "Horizontal Tab",
    image: "https://icons.veryicon.com/png/o/miscellaneous/guodong/tabs-8.png",
    shouldReceiveBuilderProps: {
      builderBlock: true,
      builderComponents: true,
      builderContext: true,
      builderLinkComponent: true,
    },
    inputs: [
      {
        name: "tabs",
        type: "list",
        required: true,
        subFields: [
          {
            name: "label",
            type: "string",
            required: true,
            localized: true,
            defaultValue: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "Tab Label",
            },
          },
          {
            name: "tabContent",
            type: "uiBlocks",
            defaultValue: [],
          },
          DLT_FIELD,
          DLD_FIELD,
        ],
        defaultValue: [
          {
            label: "Tab 1",
            tabContent: [
              {
                "@type": "@builder.io/sdk:Element",
                children: [
                  {
                    "@type": "@builder.io/sdk:Element",
                    component: {
                      name: "Text",
                      options: {
                        text: {
                          "@type": "@builder.io/core:LocalizedValue",
                          Default: "Tab 1 Content",
                        },
                      },
                    },
                    meta: {
                      localizedTextInputs: ["text"],
                      "transformed.text": "localized",
                    },
                  },
                ],
              },
            ],
            dlt: "",
            dld: "",
          },
          {
            label: "Tab 2",
            tabContent: [
              {
                "@type": "@builder.io/sdk:Element",
                children: [
                  {
                    "@type": "@builder.io/sdk:Element",
                    component: {
                      name: "Text",
                      options: {
                        text: {
                          "@type": "@builder.io/core:LocalizedValue",
                          Default: "Tab 2 Content",
                        },
                      },
                    },
                    meta: {
                      localizedTextInputs: ["text"],
                      "transformed.text": "localized",
                    },
                  },
                ],
              },
            ],
            dlt: "",
            dld: "",
          },
        ],
      },
      {
        name: "initialActiveTab",
        friendlyName: "Initial Active Tab Index",
        type: "number",
        required: false,
        localized: false,
        defaultValue: 0,
      },
      {
        name: "theme",
        type: "enum",
        helperText: "This component does not set the data-theme attribute.",
        localized: false,
        enum: [
          {
            label: "gray",
            value: "gray",
          },
          {
            label: "black",
            value: "black",
          },
          {
            label: "white",
            value: "white",
          },
        ],
        defaultValue: "gray",
      },
    ],
    canHaveChildren: true,
    defaultChildren: [
      {
        "@type": "@builder.io/sdk:Element",
        component: {
          name: "Horizontal Tab Navigation",
        },
      },
      {
        "@type": "@builder.io/sdk:Element",
        component: {
          name: "Tab Panels",
        },
      },
    ],
    defaultStyles: {
      width: "100%",
    },
  };
